import classnames from 'classnames';
import { noop, uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HelpTooltip from '../Tooltip/HelpTooltip';

export default class Checkbox extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    tooltipTitle: PropTypes.string,
    tooltipContent: PropTypes.node,
    closeTooltipByClick: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isValid: PropTypes.bool,
    validationMessage: PropTypes.string,
    readOnly: PropTypes.bool,
    isFull: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    name: null,
    readOnly: false,
    isFull: true,
    value: false,
  };

  id = uniqueId('checkbox_');

  validate() {
    const { isValid, validationMessage } = this.props;
    let message = null;

    if (validationMessage) {
      message = (
        <div className={classnames('form_error', { green: isValid, red: !isValid })}>
          {validationMessage}
        </div>
      );
    }

    return message;
  }

  renderTooltip = () => {
    const { tooltipContent } = this.props;
    let tooltip = null;

    if (tooltipContent) {
      tooltip = <HelpTooltip content={tooltipContent} title={this.props.tooltipTitle} />;
    }

    return tooltip;
  };

  renderCheckboxWrapper() {
    const { tooltipContent } = this.props;

    const classNames = classnames('form_item', this.props.className);

    return (
      <div className={classNames}>
        {!tooltipContent ? this.renderCheckbox() : this.renderHelpWrapper()}
        {this.validate()}
      </div>
    );
  }

  renderCheckbox() {
    const { name, label, value, isDisabled, readOnly, id, isFull } = this.props;
    const onChange = readOnly ? noop : this.props.onChange;
    const labelClassName = classnames('form-checkbox', {
      'form-checkbox__disable': isDisabled && !value,
      'form-checkbox__disable-check': isDisabled && value,
      'form-checkbox__inline': !isFull,
    });
    return (
      <label className={labelClassName} htmlFor={id || this.id}>
        <div className={classnames('jq-checkbox', { checked: value })}>
          <input
            name={name}
            id={id || this.id}
            type="checkbox"
            checked={value}
            disabled={isDisabled}
            readOnly={readOnly}
            onChange={(e) => onChange(e.target.checked)}
          />
          <div className="jq-checkbox__div" />
        </div>
        {!label ? null : <span className="form-checkbox_text">{label}</span>}
      </label>
    );
  }

  renderHelpWrapper = () => {
    return (
      <div className="help-wrap help-wrap__inline">
        <div className="form_wrapper">{this.renderCheckbox()}</div>
        {this.renderTooltip()}
      </div>
    );
  };

  render() {
    const { label, validationMessage } = this.props;
    return label || validationMessage ? this.renderCheckboxWrapper() : this.renderCheckbox();
  }
}
